import p1 from "./Pimg/IMG-20260531-WA0014.jpg"
import p2 from "./Pimg/IMG-20260531-WA0015.jpg"
import p3 from "./Pimg/IMG-20260531-WA0016.jpg"
import p4 from "./Pimg/IMG-20260531-WA0017.jpg"
import p5 from "./Pimg/IMG-20260531-WA0018.jpg"
import p6 from "./Pimg/IMG-20260531-WA0019.jpg"
import p7 from "./Pimg/IMG-20260531-WA0020.jpg"
import p8 from "./Pimg/IMG-20260531-WA0021.jpg"
import p9 from "./Pimg/IMG-20260531-WA0022.jpg"






const products = [
   
    {
      id: 3,
      name: "Coldest Limitless Gallon",
      category: "Bottle",
      price: 178500,
      image: p1 ,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 4,
      name: "Coldest 46oz Limitless Ultra",
      category: "Bottle",
      price: 111000,

      image:
        p2,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 5,
      name: "Coldest 36o Limitless Ultra",
      category: "Bottle",
      price: 95000,

      image:
        p3,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 6,
      name: "Coldest 24oz Limitless Ultra",
      category: "Bottle",
      price: 89400,

      image:
        p4,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 7,
      name: "Coldest 20oz Tumbler v2",
      category: "Bottle",
      price: 54900,

      image:
        p5,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 8,
      name: "Coldest 15oz Limitless Ultra",
      category: "Bottle",
      price: 74100,

      image:
        p6,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 9,
      name: "Coldest 36oz Limitless Ultra",
      category: "Bottle",
      price: 93300,

      image:
        p7,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 10,
      name: "Coldest 36oz Universal",
      category: "Bottle",
      price: 82500,

      image:
        p8,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },

    {
      id: 11,
      name: "Coldest 46oz Limitless Ultra",
      category: "Bottle",
      price: 110000,

      image:
        p9,
        shopId: "shop021",
        shopName: "The Coldest water",
      
        vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42"
    },
  ];
  
  export default products;

  